var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"py-0"},[_c('EngineParameters')],1)],1),_c('v-row',[_c('v-col',{staticClass:"py-0"},[_c('ProductSelection')],1)],1),_c('v-row',[_c('v-col',{staticClass:"py-0"},[_c('ProductRecommendation')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }